import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {PolarisRuntimeFacadeService} from '../../../../../services/polaris/polaris-runtime-facade.service';
import {ButtonComponent} from '../../../../../shared/components/button/button.component';

@Component({
  selector: 'app-copilot-followup-questions-message',
    imports: [
        NgForOf,
        NgIf,
        ButtonComponent
    ],
  templateUrl: './copilot-followup-questions-message.component.html',
  styleUrl: './copilot-followup-questions-message.component.scss'
})
export class CopilotFollowupQuestionsMessageComponent {
  @Input() followUpQuestions: string[] | undefined;
  @Input() sendMessage!: string | null;
  @Input() disabled = false;

  @Output() onError = new EventEmitter<void>();

  questionAsked = false;
  selectedQuestion = '';
  error = false;
  private readonly polarisRuntimeFacadeService = inject(PolarisRuntimeFacadeService);

  public async sendQuestion(question: string): Promise<void> {
    if (!this.questionAsked && !this.disabled) {
      this.selectedQuestion = question;
      this.questionAsked = true;
      this.error = false;
      const result = await this.polarisRuntimeFacadeService.sendMessage(this.sendMessage, question);
      if (result.status !== 'ok') {
        this.error = true;
        this.questionAsked = false;
        this.onError.emit();
      }
    }
  }

  public tryAgain(): void {
    if (!this.selectedQuestion) {
      return;
    }
    this.error = false;
    void this.sendQuestion(this.selectedQuestion);
  }

}
